import axios from '../config/axios';

const API_BASE = '/ogcl-transfer-requests';

const ogclTransferService = {
  list: (params = {}) => axios.get(API_BASE, { params }),
  get: (requestId) => axios.get(`${API_BASE}/${requestId}`),
  create: (data) => axios.post(API_BASE, data),
  approve: (requestId, data = {}) => axios.post(`${API_BASE}/${requestId}/approve`, data),
  unload: (requestId, data = {}) => axios.post(`${API_BASE}/${requestId}/unload`, data),
  reject: (requestId, data = {}) => axios.post(`${API_BASE}/${requestId}/reject`, data),
  incomingShipments: (params = {}) => axios.get(`${API_BASE}/incoming-shipments`, { params }),
  unloadBulk: (data) => axios.post(`${API_BASE}/unload-bulk`, data),
  revert: (requestId, data = {}) => axios.post(`${API_BASE}/${requestId}/revert`, data),
  revertBulk: (data) => axios.post(`${API_BASE}/revert-bulk`, data),
  undoUnload: (requestId, data = {}) => axios.post(`${API_BASE}/${requestId}/undo-unload`, data),
  undoUnloadBulk: (data) => axios.post(`${API_BASE}/undo-unload-bulk`, data),
  note: (requestId, data = {}) => axios.post(`${API_BASE}/${requestId}/note`, data),
};

export default ogclTransferService;
export { ogclTransferService };
